import React, { useEffect, useState } from 'react'
import FeatureList from './FeatureList'
import { fetchCurrentPlan, formulatePlansStructure, handlePlanStructure } from './helper'
import MonetisationCta from './MonetisationCta'
import pubsub from '@viewlift/pubsub'
import { handleStatusGaCalls } from '../helper'
import { ANALYTICSEVENTS } from '../LoginV2/Helpers/analyticsMap'
import { fetchUserObject } from '../MonetisationModule02/Stripe/helper'
import trackEvent, {getUserProperties} from '../../helpers/trackAnalytics'


const PlansList = (props) => {

  let metadataMap = props?.metadataMap
  let moneisationCta = props?.moneisationCta
  let layoutSettings = props?.layoutSettings
  const contentDetails = props?.contentData || [];
  const [plans, setPlans] = useState([])
  const [allPlans,setAllPlans] = useState([])
  const [currentStoredplan,setCurrentStoredPlan] = useState(null)
  const [defaultLoadedEvents, setDefaultLoadedEvents] = useState(null) 
  

  useEffect(() => {
      let allPlans = handlePlanStructure({ metadataMap, plans : props?.plans, subscriptionPopupFonts : props?.subscriptionPopupFonts })
      setAllPlans(allPlans)
      let plans = formulatePlansStructure({ plans: props?.plans, monetisationCTA: moneisationCta, metadataMap, subscriptionPopupFonts: props?.subscriptionPopupFonts, isTvePlan: props?.isTvePlan, isCheckout : props?.isCheckout })
      setPlans(plans)
      let currentSelectedPlan = fetchCurrentPlan()
      const isCurrentPlanSelected = props?.plans?.some(plan => plan?.id === currentSelectedPlan?.planId || plan?.id === currentSelectedPlan?.id);
      if (currentSelectedPlan && (isCurrentPlanSelected || currentSelectedPlan?.type === "TVE")) {
        setCurrentStoredPlan(currentSelectedPlan)
      }else{
        if(plans?.length > 0){
          setCurrentStoredPlan(plans[0])
        }
      }
      if(!defaultLoadedEvents){
        handlePlanSelectionEvents(plans)
      }

  }, [props?.plans,props?.isTvePlan,props?.subscriptionPopupFonts,props?.isCheckout])

  const handlePlanSelectionEvents = async (plans) => {
    setDefaultLoadedEvents(true)
    let oldPlan = fetchCurrentPlan()
    let planSelectionEventData = {
      "planId": oldPlan?.planId,
      "planName": oldPlan?.title,
      "planType": oldPlan?.cycleType,
      "planDesc": oldPlan?.description,
      "pageUrl": window?.location.href
    }
    const currentStoredplan = currentStoredplan || plans[0]
    if (oldPlan) {
      let analyticsData={ename:ANALYTICSEVENTS.PLAN_UPDATE, data: planSelectionEventData};
      pubsub.publish('user-analytics',analyticsData)
      handleStatusGaCalls({eventName : 'plan_update',subSection : null, type : 'plan', reason : oldPlan?.title, status : currentStoredplan?.title, additionalLabel : null, action : 'Update Plan', paymentStatus : null,eventCategory : 'Subscription',section : 'checkout'})
    }else {
      let analyticsData={ename:ANALYTICSEVENTS.PLAN_SELECTION, data: planSelectionEventData};
      pubsub.publish('user-analytics',analyticsData)
      handleStatusGaCalls({eventName : 'plan_selection',subSection : null, type : 'plan', reason : currentStoredplan?.title, status : null, additionalLabel : null, action : 'Plan Selection', paymentStatus : null,eventCategory : 'Subscription',section : 'checkout'})
    }
    let userData = await fetchUserObject()
    let add_to_cart_Payload = {
      section : 'checkout',
      event_label1 : currentStoredplan?.planId,
      // event_label2 : currentStoredplan?.title, // Removing due to Duplicate
      event_label2 : currentStoredplan?.type,
      event_label3 : 1,
      etstamp : Date. now(),
      logged_in_status : userData?.userId ? 'Yes'  : 'No',
      subscribed_status : userData?.isSubscribed,
      uid: userData?.userId || null,
      profid : userData?.profiles?.length ? userData?.profiles[0]?.profileId : '',
      // mobile : userData?.mobile, // Yes, collecting and sending mobile numbers to Google Analytics 4 (GA4) violates both GDPR and Google's Terms of Service,
      // last_transaction_amount : null,
      subscription_plan : currentStoredplan?.title,
      // user_location : null, //This violates GDPR/Google terms
      event_value : currentStoredplan?.amount,
      payment_status : null
    }
      
    let userProperties = await getUserProperties()
    let addToCartNewPayload = {
      ecommerce: {
        currency: currentStoredplan?.currency,
        value: currentStoredplan?.amount, 
        items: [ {...add_to_cart_Payload, ...userProperties},
        ],
      }
    }
  
    trackEvent('begin_checkout',addToCartNewPayload,null)
    trackEvent('add_to_cart', addToCartNewPayload,null)
    trackEvent('view_item', addToCartNewPayload,null)
    trackEvent('view_cart', addToCartNewPayload,null)
      
    let add_to_cart_payload_userBeacon = {
      currency: currentStoredplan?.currency, 
      items: [
        {
          item_id: currentStoredplan?.planId,
          item_name: currentStoredplan?.title,
          price: currentStoredplan?.amount,
          quantity: 1
        }
      ],
    }
    pubsub.publish('user-analytics',{ename:"add_to_cart",data:add_to_cart_payload_userBeacon})
    
  }

  return (<>
    <div className='cta-container'>
      {plans?.length ? plans?.map((plan, i) => {
        let ctaStyleType = "primary"
        if (i > 0) ctaStyleType = "secondary"
        if (plan?.type === "more") ctaStyleType = "default"
        let isActive = false
        if (currentStoredplan?.planId === plan?.planId || currentStoredplan?.id === plan?.planId) {
          isActive = true
        }
        return <MonetisationCta isActive={isActive} parentModuleData={props?.parentModuleData} key={i} plan={plan} ctaStyleType={ctaStyleType} plans={allPlans} contentDetails={contentDetails} />
      }) : <></>}
    </div>
    {props?.featureListToShow ? <FeatureList layoutSettings={layoutSettings} subscriptionPopupFonts={props?.subscriptionPopupFonts} />: <></>}
  </>)
}

export default PlansList